import { connect, useDispatch, useSelector } from 'react-redux'
import React, { useEffect, useMemo, useState } from 'react'
import { t } from 'ttag'
import USAMap from 'react-usa-map'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import { loadCollegeCounts } from '../../actions/colleges'
import { browserHistory } from '../../Routes'
import { useTitleChange } from '../../util/hooks'

const UnPositionedPopover = ({ posX, posY, selectedInfo }) => {
  return (
    <Popover
      positionLeft={`${posX}px`}
      positionTop={`${posY}px`}
      id={'CollegeCountPopover'}
      placement="right"
      style={{ zIndex: '10000000', display: selectedInfo ? 'block' : 'none' }}
      title={selectedInfo?.stateName}>
      {t`Number of Institutions: `}
      {selectedInfo?.institutionCount}
    </Popover>
  )
}
const ChooseInArea = () => {
  const [selectedInfo, setSelectedInfo] = useState(null)
  const collegeCounts = useSelector(state => state.college.collegeCounts)
  const [position, setPosition] = useState(null)
  const [stateConfig, setStateConfig] = useState(null)
  const dispatch = useDispatch()
  const mapWidth = () => {
    if (h2.isBreakpoint('lg')) {
      return 1100
    }

    if (h2.isBreakpoint('md')) {
      return 900
    }

    if (h2.isBreakpoint('sm')) {
      return 700
    }

    return 350
  }

  useTitleChange(t`Colleges in Your Area`)

  const handleMapClick = event => {
    const stateId = event.target.dataset.name

    browserHistory.push(`/colleges/list?state=${stateId}`)
  }
  const handleHover = stateId => {
    return event => {
      const count = collegeCounts?.result?.find(cCount => {
        return cCount.stateAbbreviation == stateId
      })

      setSelectedInfo(count)
      setPosition({
        posX: event.pageX,
        posY: event.pageY - 60
      })
    }
  }
  const handleHoverOut = () => {
    setSelectedInfo(null)
  }

  useEffect(() => {
    dispatch(loadCollegeCounts())
  }, [])

  useEffect(() => {
    const eventOver = event => {
      handleHover(event.target.dataset.name)(event)
    }
    const tags = document.getElementsByTagName('path')

    Array.from(tags).forEach(ele => {
      ele.addEventListener('mouseenter', eventOver)
      ele.addEventListener('mouseleave', handleHoverOut)
    })

    return () => {
      Array.from(tags).forEach(ele => {
        ele.removeEventListener('mouseenter', eventOver)
        ele.removeEventListener('mouseleave', handleHoverOut)
      })
    }
  }, [collegeCounts])

  useEffect(() => {
    const counts = collegeCounts?.result?.map(c => c.institutionCount)
    //console.log(counts)
    const minInst = counts ? Math.min(...counts) : 1
    const maxInst = counts ? Math.max(...counts) : 2
    const _stateConfig = collegeCounts?.result
      ?.map(({ stateAbbreviation, institutionCount }) => {
        const opacity = 1 * ((maxInst - institutionCount) / (maxInst - minInst))
        const finalRed = Math.round(18 * (1 - opacity) + 255 * opacity)
        const finalGreen = Math.round(150 * (1 - opacity) + 255 * opacity)
        const finalBlue = Math.round(24 * (1 - opacity) + 255 * opacity)
        const fill = `#${finalRed.toString(16)}${finalGreen.toString(
          16
        )}${finalBlue.toString(16)}`

        //console.log(fill)
        return {
          [stateAbbreviation]: {
            stroke: '#888',
            strokeWidth: 1,
            fill
          }
        }
      })
      .reduce((a, b) => ({ ...a, ...b }), {})

    setStateConfig(_stateConfig)
  }, [collegeCounts])

  const pop = (
    <Popover
      id={'CollegeCountPopover2'}
      placement="right"
      style={{
        zIndex: '10000000',
        display: selectedInfo ? 'block' : 'none'
      }}
      title={selectedInfo?.stateName}>
      {t`Number of Institutions: `}
      {selectedInfo?.institutionCount}
    </Popover>
  )

  return (
    <div className="container">
      <p>{t`To view colleges in your area, select your state from the map below or click on the state name in the listing at the bottom of the page. Darker colors on a state indicate a higher number of colleges.`}</p>
      <OverlayTrigger
        trigger={['hover', 'focus', 'click']}
        placement="right"
        overlay={(
          <UnPositionedPopover
            posX={position?.posX}
            posY={position?.posY}
            selectedInfo={selectedInfo}
          />
        )}>
        <div className="college-selection-map">
          <USAMap onClick={handleMapClick} width={mapWidth()} customize={stateConfig} />
        </div>
      </OverlayTrigger>
      <ul style={{ columns: '4' }}>
        {collegeCounts?.result?.map(c => (
          <li key={`li-state-${c.stateName}`}>
            <OverlayTrigger
              trigger={['hover', 'focus', 'click']}
              placement="right"
              overlay={pop}>
              <Link
                to={`/colleges/list?state=${c.stateAbbreviation}`}
                onMouseOver={handleHover(c.stateAbbreviation)}
                onMouseOut={handleHoverOut}>
                {c.stateName}
              </Link>
            </OverlayTrigger>
          </li>
        ))}
      </ul>
      <br />
    </div>
  )
}

export { ChooseInArea }
